__turbopack_context__.v({
  "badge": "IGR4sW_badge",
  "bump": "IGR4sW_bump",
  "core": "IGR4sW_core",
  "ring": "IGR4sW_ring",
  "ripple": "IGR4sW_ripple",
  "spin": "IGR4sW_spin",
  "thump": "IGR4sW_thump",
});
